import { DEFAULT_MOSCOW_REGION } from '../../constants/region';
import { ILocation } from '../../types/location';
import { createNoopReducer } from '../../utils/redux/createNoopReducer';

export const INITIAL_STATE = DEFAULT_MOSCOW_REGION;

export const locationReducer = createNoopReducer<ILocation>(INITIAL_STATE);
